// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__UGFtL","content":"ManualTimeModal_content__1SfbE"};